const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://54sb4hp1lh.execute-api.us-west-2.amazonaws.com/prod',
    TEAM_API_URL: 'https://2o38adt0cc.execute-api.us-west-2.amazonaws.com/api'
  },
  reactApp: {
    VERSION: 'taxonomy-teams-1.15.5',
    HOSTNAME: 'https://teams-service.evolution.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.evolution.forwoodsafety.com',
    WEBSOCKET: 'wss://n85utmo5h5.execute-api.us-west-2.amazonaws.com/prod'
  },
};

export default config;
